import FormError from "./form-error";
import Recap from "./recapitulatif";

export default function ButtonSection(props) {
	const handler =  () =>  (props.action());
	const {data , step , restart} = props;

	return <div className="buttons-container">
		<FormError errors={props.errors}/>
		<button onClick={handler}
		 className={"button button-primary"+ (props.dataValid ? " active" : " disabled") }
		> Suivant</button>
		<span className='step'>Étape {step} / 7</span>
		<button onClick={restart} className="instep-restart-btn">Recommencer</button>
		<Recap data={data}></Recap>
	</div>;
}
